import { Badge } from "@/atoms"
import { useFilters } from "@/hooks/useFilters"
import { CheckboxFilter } from "../CheckboxFilter"

import styles from "./CountedCheckboxFilter.module.scss"

import type { CountedCheckboxFilterProps, CountedOption } from "."

const renderCount = (count = 0) =>
  count > 0 && <Badge className={styles.count} count={count} />

// A checkbox filter whose options carry a count; the filter shows their sum until any option is selected.
export const CountedCheckboxFilter = (props: CountedCheckboxFilterProps) => {
  const { items = [], keyFilter } = props
  const { searchParams } = useFilters()
  const anySelected = !!searchParams.get(keyFilter)
  const total = items.reduce((sum, { count = 0 }) => sum + count, 0)

  return (
    <CheckboxFilter
      {...props}
      renderOptionSuffix={(option: CountedOption) => renderCount(option.count)}
      labelSuffix={!anySelected && renderCount(total)}
    />
  )
}
